import { useState, type ReactNode } from 'react';
import { useAppStatusQuery } from '@/features/appStatus/api/useAppStatusQuery';
import { AppStatusPage } from '@/features/appStatus/pages/AppStatusPage';

type AppStatusGateProps = {
  children: ReactNode;
};

/**
 * When API says showPopup, overlay the status page (maintenance / issue /
 * demo / launch). Keep the router mounted so a status refetch cannot
 * remount the whole app. Closable only if API allows.
 */
export function AppStatusGate({ children }: AppStatusGateProps) {
  const { data, isError } = useAppStatusQuery();
  const [dismissed, setDismissed] = useState(false);

  const config = data?.data;
  const shouldBlock =
    Boolean(config?.showPopup) && !dismissed && !isError;

  return (
    <>
      {children}
      {shouldBlock && config ? (
        <div className="fixed inset-0 z-[10000]">
          <AppStatusPage
            config={config}
            onClose={
              config.isCloseable ? () => setDismissed(true) : undefined
            }
          />
        </div>
      ) : null}
    </>
  );
}
